export async function rateAiCoachContent(_ref) {
  let {
    aiCoachContentProperty,
    campusApiUrl,
    derivedCourseContentId,
    isHelpful,
    language
  } = _ref;
  await fetch("".concat(campusApiUrl, "/api/derivedCourseContent/").concat(derivedCourseContentId, "/rate"), {
    body: JSON.stringify({
      aiCoachContentProperty,
      isHelpful
    }),
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-dc-lang': language
    },
    method: 'POST'
  });
}